import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { CreateBoard } from '..';

export function useCreateBoard() {
  const { workspaceId } = useWorkspaceId();
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: ({ title }: { title: string }) => CreateBoard(workspaceId, { title }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.board.all() });
    },
  });
}
